const set_client_listing = (state, clients) => {
  state.clients = clients;
};

const set_client = (state, client) => {
  state.client = client;
};

const set_site_listing = (state, sites) => {
  state.sites = sites;
};

const set_site = (state, site) => {
  state.site = site;
};

const set_building_listing = (state, buildings) => {
  state.buildings = buildings;
};

const set_building = (state, building) => {
  state.building = building;
};

const set_plant_listing = (state, plants) => {
  state.plants = plants;
};

const set_plant = (state, plant) => {
  state.plant = plant;
};

export default {
  set_client,
  set_client_listing,
  set_site_listing,
  set_site,
  set_building_listing,
  set_building,
  set_plant_listing,
  set_plant
};
